import gql from 'graphql-tag';
import { contestantFragments } from 'graphql/fragments/Contestant';
const {
  ContestantId,
  ContestantName,
  ContestantAddress,
  ContestantSocialAccounts,
} = contestantFragments;

export const GET_ATHLETES = gql`
  query GET_ATHLETES($input: ContestantsInput!) {
    athletesPayload(input: $input) {
      athletes {
        ...ContestantId
        ...ContestantName
        ...ContestantAddress
        ...ContestantSocialAccounts
        CType
        StatusType
        AdminNotes
        Penalty
        BioUID
        AwardUID
        HeritageUID
        HistoryUID
        InjuryCurrentUID
        InjuryHistoryUID
        QuoteUID
        PhotoUID
        Identifier
        ContractorUID
        Brand
        Hometown
        Website
        RookieYear
        Height
        Weight
        createdAt
        LastUpdate
        MemType
        PurchaseDate
        Disc
        DOBVerified
        CareerEarnings
        WorldChampionshipEarned
        PayeeNumber
        PhotoFilename
        email
        socialTags
        role
        status
        DOB
        Gender
        Phone
        SSN
        USCitizen
        isParent
        isAthlete
        isYouth
        type
        isUnregisteredAthlete
        PayeeNumber
        linkedAccounts {
          ERAUID
          parentId
          FullName
          DOB
          Discipline
          Disc
          Email
        }
        disciplineAsString
        isUnregisteredAthlete
      }
      meta(input: $input) {
        totalCount
      }
    }
  }
  ${ContestantId}
  ${ContestantName}
  ${ContestantAddress}
  ${ContestantSocialAccounts}
`;
